import { createSelector } from '@reduxjs/toolkit';
import { alphaSort } from 'vet-bones/utils';

import { AttributeTableItem } from 'src/containers/ProjectDiagram/components/attributesTable/types';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectAttributeRangesByIriSelector } from 'src/selectors/projectAttributeRangesByIri';
import { projectAttributesByIriSelector } from 'src/selectors/projectAttributesByIri';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import * as copy from 'src/templates/copy';

export const projectAttributeItemsSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectLabelsByIriSelector(projectId),
      projectAttributesByIriSelector(projectId),
      projectAttributeRangesByIriSelector(projectId),
      (labelsByIri, attributesByIri, rangesByIri) =>
        Object.values(attributesByIri)
          .map(
            (attribute): AttributeTableItem => ({
              text: getLabelForIri(
                labelsByIri,
                attribute.value,
                copy.components.projectDiagram.modelConceptAttribute.new
              ),
              value: attribute.value,
              ranges: rangesByIri[attribute.value] || [],
            })
          )
          .sort(alphaSort((item) => item.text))
    )
);
